import React from "react"
import Img from "gatsby-image"
import { getFluidGatsbyImage } from "gatsby-source-sanity"
import clientConfig from "../../../client-config"
import { getImageDetail } from "@utilities/helpers"

const Figure = ({ node }: any) => {
  if (!node.asset) {
    return null
  }
  const imageId = node.asset.id || node.asset._ref
  const { dimensions } = getImageDetail(imageId)
  const fluidProps = getFluidGatsbyImage(
    imageId,
    { maxWidth: 675 },
    clientConfig.sanity
  )

  return (
    <figure
      className="max-w-full"
      style={{ width: dimensions && dimensions.width }}
    >
      <Img fluid={fluidProps} alt={node.alt} />
      {node.caption && <figcaption>{node.caption}</figcaption>}
    </figure>
  )
}

export default Figure
